
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class App extends Vue {
  @Prop({ type: Object, default: {} }) info!: any;

  isShowPage = false; //是否展示页面
  videoPlay = require("@/assets/videoPlay.png");
  wxBgBorder =
    "https://oss.hina.com/app/hina/2021/07/10/3f1396a2ddd6a8493c582f22c69dae39.png";
  connectCode = "";
  mainColor = "";
  examName = "";
  textOpacity = 1.0;
  examExpireTextMessage = "";
  examExpireTitle = "";
  publicityPageVideoCoverUrl = "";
  publicityPageVideoUrl = "";
  videoPlaying = false;
  video: any = null;

  contentOverflow = "hidden";
  scrollHeight = 0;
  touchHeight = 0;
  footerHeight = 0;

  isInvalidNetwork = false;

  // 刷新当前页
  refresh() {
    location.reload();
  }

  onChange() {
    this.video[["play", "pause"][Number(this.videoPlaying)]]();
    this.videoPlaying = !this.videoPlaying;
  }

  // 查看更多
  get checkMoreText(): boolean {
    return this.textOpacity > 0 && this.touchHeight > 228;
  }

  // 面试不存在
  onInvalidExam() {
    this.isShowPage = true;
    // this.examExpireTextMessage = "该面试不存在，请参与正确的面试场次";
    this.publicityPageVideoCoverUrl = this.wxBgBorder;
    this.examName = this.isInvalidNetwork
      ? "很抱歉，由于网络连接问题，我们无法加载您的面试信息。请检查您的网络连接并重试。"
      : "当前面试链接已失效，请您尽快与相关工作人员联系";
    this.examExpireTitle = this.isInvalidNetwork ? "刷新页面" : "面试已失效";
    this.setContentScroll();
  }

  // 面试结束
  @Watch("info")
  setStatusInfo() {
    if (!this.info) {
      return;
    }
    this.examName = this.info.examName;
    this.publicityPageVideoUrl = this.info.publicityPageVideoUrl;
    this.publicityPageVideoCoverUrl = this.info.publicityPageVideoCoverUrl;
    this.examExpireTextMessage = this.info.examExpireTextMessage;
    this.mainColor = this.info.styleConfig?.mainColor;
    this.setContentScroll();
    if (this.publicityPageVideoUrl) {
      this.$nextTick(() => {
        this.video = this.$refs.resultVideo as HTMLVideoElement;
      });
    }
    if (this.info.joinStatus === 1) {
      this.examExpireTitle = "面试未开始";
    } else if (
      this.info.isExpireRegisterTimeLimit === 1 ||
      this.info.joinStatus === 2
    ) {
      this.examExpireTitle = "面试已结束";
    }
  }
  @Watch("publicityPageVideoUrl")
  setVideo() {
    if (this.publicityPageVideoUrl) {
      this.$nextTick(() => {
        this.video = this.$refs.resultVideo as HTMLVideoElement;
      });
    }
  }

  // 设置内容区滚动
  setContentScroll() {
    try {
      this.$nextTick(() => {
        this.scrollHeight = (document.querySelector(
          ".scroll"
        ) as HTMLElement).offsetHeight;
        this.contentOverflow = this.scrollHeight === 0 ? "auto" : "hidden";
        this.touchHeight = (document.querySelector(
          ".touch"
        ) as HTMLElement).offsetHeight;
        this.footerHeight = (document.querySelector(
          ".footer"
        ) as HTMLElement).offsetHeight;
      });
    } catch (e) {
      console.error("🚀 ~ H5 face verify ~ result ~ setContentScroll ~ e:", e);
    }
  }

  onScroll(e: any) {
    try {
      const heightPoor =
        this.scrollHeight + this.touchHeight - this.footerHeight;
      const scrollTop = heightPoor > 50 ? 50 : heightPoor;
      this.contentOverflow =
        e.target.scrollTop === this.scrollHeight ? "auto" : "hidden";
      if (scrollTop >= e.target.scrollTop && e.target.scrollTop >= 0) {
        this.textOpacity = (scrollTop - e.target.scrollTop) / scrollTop;
      } else if (scrollTop < e.target.scrollTop) {
        this.textOpacity = 0.0;
      }
    } catch (e) {
      console.log("🚀 ~ H5 face verify ~ result ~ onScroll ~ e:", e);
    }
  }
}
